module.exports = __webpack_public_path__ + "media/images/sp/specials/okinawa_churaumi_aquarium/schedule_01-9ede04f9195507f7cdfc85df4016c48a.jpg";